export class Notifications {
  static LIKE_NEW_ATTENDEE_PAGE = "like-new-attendee-page"
  static LIKE_NEW_CONTACT_PAGE = "like-new-contact-page"
}
